module.exports = __webpack_public_path__ + "img/四川天府新区耘朵幼儿园.4d152981.jpg";